import { render, staticRenderFns } from "./_winpay.vue?vue&type=template&id=a68f816e&lang=pug&"
import script from "./_winpay.vue?vue&type=script&lang=js&"
export * from "./_winpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports